import { convertToDynamicPagePanelV2 } from '@wix/wix-data-client-common/dist/esm/panels/panelDefs'
import getPanelUrl from '@wix/wix-data-client-common/dist/esm/panels/getPanelUrl'

export default async ({
  editorSdkProxy,
  appApi,
  hostname,
  initialData: { pageRef, origin, editorType },
}) => {
  const [url] = await Promise.all([
    getPanelUrl({
      editorSdkProxy,
      hostname,
      relativeUrl: convertToDynamicPagePanelV2.url,
    }),
    ensureCurrentPage(),
  ])

  try {
    await editorSdkProxy.editor.closePagesPanel()
    return await editorSdkProxy.editor.openSidePanel({
      url,
      initialData: { pageRef, origin, editorType },
      displayAboveModals: false,
    })
  } catch (error) {
    const wrappedError = new Error(
      'Failed to open convert to dynamic page panel',
      { cause: error },
    )
    appApi.emit('pageConversionEnded', { error: wrappedError })
    throw wrappedError
  }

  async function ensureCurrentPage() {
    const currentPageRef = await editorSdkProxy.pages.getCurrent()
    if (currentPageRef.id !== pageRef.id) {
      return editorSdkProxy.pages.navigateTo({ pageRef })
    }
  }
}
